import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            meta: {layout: 'auth', title: 'Giris ekrani'},
            component: () => import(/* webpackChunkName: "giris-1" */ './views/Giris.vue')
        },
        {
            path: '/kontrol-paneli',
            name: 'kontrol-paneli',
            meta: { layout: 'default', title: 'Kontrol Paneli'},
            component: () => import(/* webpackChunkName: "kontrol-paneli" */ './views/Dashboard.vue')
        },
        {
            path: '/harita',
            name: 'harita',
            meta: {layout: 'auth'},
            component: () => import(/* webpackChunkName: "harita" */ './views/Dashboard.vue')
        },
        {
            path: '/test',
            name: 'test',
            meta: {layout: 'default'},
            component: () => import(/* webpackChunkName: "test" */ './views/Test.vue')
        },
        {
            path: '/kontrol-planlama',
            name: 'kontrol-planlama',
            meta: {layout: 'default', title: 'Kontrol Planlama'},
            component: () => import(/* webpackChunkName: "test" */ './views/KontrolPlanlama.vue')
        },
        {
            path: '/kontrol-gecmisi',
            name: 'kontrol-gecmisi',
            meta: {layout: 'default', title: 'Kontrol Geçmişi'},
            component: () => import(/* webpackChunkName: "test" */ './views/KontrolGecmisi.vue')
        },
        {
            path: '/map',
            name: 'map',
            meta: {layout: 'default'},
            component: () => import(/* webpackChunkName: "home" */ './views/Map.vue')
        },
        {
            path: '/giris',
            name: 'giris',
            meta: {layout: 'auth', title: 'Giris Ekrani'},
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "giris" */ './views/Giris.vue')
        },
        {
            path: '/fatura',
            name: 'fatura',
            meta: {layout: 'default', title: 'Fatura Bilgileri'},
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "sirket" */ './views/SirketList.vue')
        },
        {
            path: '/koku',
            name: 'koku',
            meta: { layout: 'default', title: 'Koku Bilgileri' },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "koku" */ './views/KokuList.vue')
        },
        {
            path: '/makina',
            name: 'makina',
            meta: { layout: 'default', title: 'Makina Bilgileri' },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "makina" */ './views/MakinaList.vue')
        },
        {
            path: '/musteri',
            name: 'musteri',
            meta: { layout: 'default', title: 'Müşteriler' },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "musteri-index" */ './views/musteri-list/index.vue')
        },
        {
            path: '/musteri/kayit/',
            name: 'musteri-kayit',
            meta: { layout: 'default', title: 'Müşteri kayıt' },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "musteri-kayit" */ './views/MusteriForm.vue')
        },
        {
            path: '/musteri/kayit/:id?',
            name: 'musteri-guncelle',
            meta: { layout: 'default', title: 'Müşteri guncelle'  },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "musteri-kayit" */ './views/MusteriGuncelle.vue')
        },
        {
            path: '/musteri-bilgi/:id?',
            name: 'musteri-bilgi',
            meta: { layout: 'default', title: 'Müşteri Profil'  },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "musteri-info" */ './views/musteri-info/index.vue')
        },
        {
            path: '/musteri-kontroller',
            name: 'musteri-kontrolleri',
            meta: { layout: 'default', title: 'Müşteri Kontrolleri'  },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "musteri-kontrolleri" */ './views/MusteriKontrolleri.vue')
        },
        {
            path: '/kontroller',
            name: 'kontroller',
            meta: { layout: 'default', title: 'Müşteri Kontrolleri'  },
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "kontroller" */ './views/Kontroller.vue')
        },
        {
            path: '/gider-yonetimi',
            name: 'gider-yonetimi',
            meta: { layout: 'default', title: 'Gider Yönetimi'  },
            component: () => import(/* webpackChunkName: "kontroller" */ './views/GiderYonetimi.vue')
        },
        {
            path: '/gunluk-kontroller',
            name: 'gunluk-kontroller',
            meta: { layout: 'default', title: 'Günlük Kontroller'  },
            component: () => import(/* webpackChunkName: "gunluk-kontroller" */ './views/GunlukKontroller.vue')
        },
    ]
})
